export default __webpack_public_path__ + "static/media/prod-page-epi.141e154f.jpg";